module.exports = __webpack_public_path__ + "static/media/locked.a3f3f744.svg";